function SmallBanner() {
    return(
        <section className="small-banner ">
            <div className="small-banner-overlay flex center">
                <p className="small-banner-title">New here? Hurry! Get 50% off your first order.</p>
            </div>
        </section>
    );
}

export default SmallBanner;